export const formatPrice = (price?: number, stringIfNoPrice?: string) => {
  if (!!price && price > 0) {
    return price.toLocaleString('sv-SE');
  }

  return stringIfNoPrice ?? 'Inget pris';
};

export const getLowestMainPlanPrice = (
  intermediateMonthlyPrice?: number | null,
  regularMonthlyPrice?: number | null,
  monthlyPrice?: number | null,
  downPayment?: number | null,
) => {
  const intermediateMainPlanPrice =
    (intermediateMonthlyPrice || 0) - (downPayment || 0);
  const mainPlanPrice = regularMonthlyPrice || monthlyPrice || 0;

  if (intermediateMainPlanPrice === 0 || intermediateMainPlanPrice < 0) {
    return mainPlanPrice;
  }

  if (mainPlanPrice === 0) {
    return intermediateMainPlanPrice;
  }

  return Math.min(intermediateMainPlanPrice, mainPlanPrice);
};
